import { clientShopId } from 'config/const';
import { callTpFetch, idTokenHeader, tokenHeader, header } from './utils';

const EndPoint = {
  GetShop: (lineId) =>
    `/linewebhook/shops/shop/${clientShopId}/oauth/${lineId}/info?options=annotations,settings.formica,branches`,
  GetProducts: () => `/linewebhook/product/shop/${clientShopId}`,
  GetCategories: () => `/linewebhook/category/shop/${clientShopId}`,
  GetProductTags: () => `/linewebhook/product-tag/shop/${clientShopId}`,
  GetCategoryTags: () => `/linewebhook/category-tag/shop/${clientShopId}`,
  getCustomerTags: () => `/linewebhook/tag/shop/${clientShopId}`,
  GetImages: ({ title = '', desc = '' }) =>
    `/linewebhook/image/shop/${clientShopId}?title=${title}&desc=${desc}`,
  GetPages: (actions) =>
    `/linewebhook/page/shop/${clientShopId}?actions=${actions.join(',')}`,
  GetContentPages: () => `/linewebhook/content/shop/${clientShopId}/pages`,
  GetContentCategory: () =>
    `/linewebhook/content/shop/${clientShopId}/category`,
  GetContentPageById: (pageId) =>
    `/linewebhook/content/shop/${clientShopId}/pages/${pageId}`,
  GetSettings: () => `/linewebhook/content/shop/${clientShopId}/settings`,
};

// Shop
export function getShop(liffToken, lineId) {
  const uri = EndPoint.GetShop(lineId);
  let settings = {
    method: 'POST',
    headers: header,
    body: JSON.stringify({
      accessToken: liffToken,
    }),
  };

  return callTpFetch(uri, settings);
}

export function getProducts(idToken) {
  const uri = EndPoint.GetProducts();
  let settings = {
    method: 'GET',
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
  };

  return callTpFetch(uri, settings);
}

export function getCategories(idToken) {
  const uri = EndPoint.GetCategories();
  let settings = {
    method: 'GET',
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
  };

  return callTpFetch(uri, settings);
}

export function getCustomerTags(idToken) {
  const uri = EndPoint.GetCustomerTags();
  let settings = {
    method: 'GET',
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
  };

  return callTpFetch(uri, settings);
}

export function getCategoryTags(idToken) {
  const uri = EndPoint.GetCategoryTags();
  let settings = {
    method: 'GET',
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
  };

  return callTpFetch(uri, settings);
}

export function getProductTags(idToken) {
  const uri = EndPoint.GetProductTags();
  let settings = {
    method: 'GET',
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
  };

  return callTpFetch(uri, settings);
}

export function getImages(idToken, query = { title: '', desc: '' }) {
  const uri = EndPoint.GetImages(query);
  let settings = {
    method: 'GET',
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
  };

  return callTpFetch(uri, settings);
}

export function getPages(idToken, actions = []) {
  const uri = EndPoint.GetPages(actions);
  let settings = {
    method: 'GET',
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
  };

  return callTpFetch(uri, settings);
}

export function getContentCategory(idToken, options = {}) {
  const uri = EndPoint.GetContentCategory();
  let settings = {
    method: 'GET',
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
    ...options,
  };

  return callTpFetch(uri, settings);
}

export function getContentPages(idToken, options = {}) {
  const uri = EndPoint.GetContentPages();
  let settings = {
    method: 'GET',
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
    ...options,
  };

  return callTpFetch(uri, settings);
}

export function getContentPageById(idToken, pageId, options = {}) {
  const uri = EndPoint.GetContentPageById(pageId);
  let settings = {
    method: 'GET',
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
    ...options,
  };

  return callTpFetch(uri, settings);
}

// export function getSettings(idToken) {
//   const uri = EndPoint.GetSettings();
//   let settings = {
//     method: "GET",
//     headers: { ...idTokenHeader(idToken), ...tokenHeader },
//   };

//   return new Promise((resolve) => {
//     resolve(mock_settings);
//   });
//   return callTpFetch(uri, settings);
// }
